import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex } from '@chakra-ui/react'
import '../styles/dsr-display.scss'
import { resetUpdateDsrOutcome, updateDsr } from '../actions/dsr-actions'
import PageLoader from '../../global/components/helper-components/components/PageLoader'
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import { AiFillCheckCircle } from 'react-icons/ai'
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal'


function DsrPublishCardModal({ modalTransferPayload, handleCloseModal, updateDsr, updateDsrOutcome, resetUpdateDsrOutcome }) {

  // UX Management
  const [showLoader, setShowLoader] = useState(false)
  const { dsrId, dsrTitle } = modalTransferPayload || {}

  useEffect(() => {
    if (updateDsrOutcome) {
      const { updateDsrStatus } = updateDsrOutcome || {};

      if (updateDsrStatus) {
        setShowLoader(false)
        resetUpdateDsrOutcome()
        handleCloseModal()
      }
    }
  }, [updateDsrOutcome]);


  const handleClickPublishButton = () => {
    setShowLoader(true);
    updateDsr({ dsrId, status: 'active', sourceEvent: "republish-dsr" })
  }


  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    if (!showLoader) {
      return (
        <Box w='100%' p='1em 1.8em'>
          <Flex w="100%" fontSize='0.875em' color='brandDark.500'>
            Publish it and share Room with its members again?
          </Flex>

          <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
            <LaunchdeckButton bg='brand.500' w={['100%', 'auto']} color='gray.50' fontSize='0.8em' py='0.4em' onClick={() => handleClickPublishButton()} label='Yes, publish again' />
          </Flex>
        </Box>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={<Flex gap='1em' justify='flex-start' align='center'>
        <Box as={AiFillCheckCircle} color='brand.500' boxSize="1.6em" />
        <Box color='white'>You are about to publish <i>{dsrTitle || "this Room"}</i> again</Box>
      </Flex>}
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    updateDsrOutcome: state.updateDsrOutcome.results.data
  };
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsr,
      resetUpdateDsrOutcome
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrPublishCardModal));
